export default "__VITE_ASSET__BOZspi9t__"